import _ from "underscore";
import basePath from "base_path";
import ActionTypes, {WorkflowsActionTypes} from "../constants/action_types";
import {buildQuery} from "utils/uri";

import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {AggregatedWorkflowTest} from "common/flowmaster/types/test";

export type WorkflowTestsFetchAction = {
  type: WorkflowsActionTypes["WORKFLOW_TESTS_FETCH"]["SUCCESS"];
  payload: AggregatedWorkflowTest[];
};

function pickFilter(value) {
  return Array.isArray(value) ? value.length > 0 : Boolean(value);
}
export default function fetchWorkflowTests(requestor) {
  return createReduxPromiseAction(
    ActionTypes.WORKFLOW_TESTS_FETCH,
    (organisationId: OrganisationId, filters) => {
      const query = buildQuery({
        ..._.pick({...filters}, pickFilter),
        // max_runs: maxRuns,
      });
      return requestor
        .get(
          `${basePath}/organisation/${organisationId}/workflow_test${query}`,
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
